import Notification from './Notification.vue';

// @ts-ignore
Notification.install = (Vue) => {
  Vue.component((Notification as any).options.name, Notification);
};

export default Notification;
